import Vue from 'vue';
import types from '../mutation-types';
import ActivityAgendaAPI from '../../api/activityAgenda';
import { browserTimeZone } from '../../helper/activityAgendaHelper';

let latestSummaryRequestId = 0;

const startSummaryRequest = () => {
  latestSummaryRequestId += 1;
  return latestSummaryRequestId;
};

const commitLatestSummary = (commit, requestId, data) => {
  if (requestId !== latestSummaryRequestId) return;
  commit(types.SET_ACTIVITY_AGENDA_SUMMARY, data);
};

const state = {
  summary: {
    todayCount: 0,
    overdueCount: 0,
    nextOverdueAt: null,
  },
};

export const getters = {
  getSummary($state) {
    return $state.summary;
  },
};

export const actions = {
  fetchSummary: async ({ commit }) => {
    const requestId = startSummaryRequest();
    const { data } = await ActivityAgendaAPI.summary({
      timezone: browserTimeZone(),
    });
    commitLatestSummary(commit, requestId, data);
    return data;
  },
  list: async ({ commit }, { page = 1, perPage } = {}) => {
    const requestId = startSummaryRequest();
    const { data } = await ActivityAgendaAPI.list({
      page,
      per_page: perPage,
      timezone: browserTimeZone(),
    });
    commitLatestSummary(commit, requestId, data.meta);
    return data;
  },
};

export const mutations = {
  [types.SET_ACTIVITY_AGENDA_SUMMARY]($state, data = {}) {
    Vue.set($state, 'summary', {
      todayCount: Number(data.today_count) || 0,
      overdueCount: Number(data.overdue_count) || 0,
      nextOverdueAt: data.next_overdue_at || null,
    });
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
